const link = {
  defaultProps: {
    underline: 'none',
    color: 'inherit',
    fontSize: 'inherit',
  },
};

export default link;
